module.exports = __webpack_public_path__ + "static/img/logo.cd868fca.png";